import React, { Fragment, useState } from "react";
import FormSection from "./formSection";
import "../../assets/css/scss/component/authentication/_rightSideSection.scss";
import { Nav } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import usePathname from "../../common/getActiveRoute";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { IReduxStateData } from "../../interfaces/redux";
import { useSelector } from "react-redux";
import { LOGIN_PAGE, SIGN_UP_PAGE } from "../../constant/menuAndProfile";

export default function RightSideSection(props: any) {
  const urlLink = usePathname()?.split("/");
  const [redirectPage, setRedirectPage] = useState("")
  const [isBackButtonDisplay, setBackButtonDisplay] = useState(false)
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";
  const clickOnTab = (redirect: string) => {
    setRedirectPage(redirect)
  }
  const changeBackButton = (backbutton: boolean) => {
    setBackButtonDisplay(backbutton)
  }
  console.log("asdad >", urlLink)
  return (
    <Fragment>
      {redirectPage ? <Redirect to={redirectPage} /> : null}
      <div className="right-sidebar">
        <div className="nav-tabs-login">
          <Nav bsPrefix={"nav nav-tabs justify-content-md-end " + (isBackButtonDisplay ? "back-btn" : "")} as="ul">
            {isBackButtonDisplay ?
              <Nav.Item as="li">
                <Nav.Link className={`theme-white font-regular back-link`} eventKey="first" onClick={() => setBackButtonDisplay(false)}>
                  <FaArrowAltCircleLeft />
                </Nav.Link>
              </Nav.Item>
              : null
            }
            <Nav.Item as="li">
              <Nav.Link className={`theme-white font-regular ${urlLink.includes("login") ? "active" : ""}`} eventKey="second" onClick={() => clickOnTab('/login')}>
                {LOGIN_PAGE[selectedLang]['title']}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li">
              <Nav.Link className={`theme-white font-regular ${urlLink.includes("register") ? "active" : ""}`} eventKey="third" onClick={() => clickOnTab('/register')}>
                {SIGN_UP_PAGE[selectedLang]['title']}
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
        <div className="login-form d-flex align-items-center justify-content-center">
          <FormSection {...props} backButtonClick={(data: boolean) => changeBackButton(data)} isBackButtonDisplay={isBackButtonDisplay} />
        </div>
      </div>
    </Fragment>
  );
}
